"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CandidateEducationSchema = void 0;
const zod_1 = __importDefault(require("zod"));
const shared_1 = require("../shared");
const candidate_enum_1 = require("./candidate.enum");
exports.CandidateEducationSchema = zod_1.default.object({
    id: shared_1.UUIDSchema,
    candidateId: shared_1.UUIDSchema,
    status: candidate_enum_1.GraduationStatusEnum,
    fieldOfStudy: zod_1.default.string(),
    institution: zod_1.default.string(),
    endDate: shared_1.ISODateSchema.nullable(),
    startDate: shared_1.ISODateSchema.nullable(),
    level: candidate_enum_1.EducationLevelEnum,
    createdAt: shared_1.ISODateTimeSchema,
    updatedAt: shared_1.ISODateTimeSchema,
});
